@if (thomas.available) {
  <button #launcher type="button" class="thomas-launcher" [class.open]="thomas.open" title="Ask Thomas" aria-label="Ask Thomas"
    [attr.aria-expanded]="thomas.open" (click)="thomas.toggle()">
    <img class="thomas-launcher-logo" src="assets/ask-ai-logo.png" alt="Ask AI" />
  </button>

  @if (!thomas.docked) {
    <dx-popup [(visible)]="thomas.open" [wrapperAttr]="wrapperAttr" [position]="position"
      [width]="600" [height]="600" [minWidth]="phoneSize ? 0 : 320" [minHeight]="phoneSize ? 0 : 'min(380px, calc(100dvh - 64px))'"
      [maxWidth]="phoneSize ? '100vw' : 'min(800px, calc(100vw - 24px))'" [maxHeight]="phoneSize ? '100dvh' : 'calc(100dvh - 64px)'"
      [fullScreen]="phoneSize" [dragEnabled]="!phoneSize" [dragOutsideBoundary]="false" [resizeEnabled]="!phoneSize"
      [shading]="false" [hideOnOutsideClick]="false" [showTitle]="true" [showCloseButton]="false"
      (onShown)="onShown($event)" (onHidden)="onHidden()" (onContentReady)="onContentReady($event)">
      <div *dxTemplate="let data of 'title'" class="thomas-header">
        <button type="button" class="thomas-header-button" title="New conversation" aria-label="New conversation" (click)="newConversation()">
          <i class="material-icons">refresh</i>
        </button>
        <span class="thomas-header-title">Truth Engine AI Assistant</span>
        <span class="thomas-header-actions">
          @if (thomas.dockable && !thomas.managingPrompts) {
            <button type="button" class="thomas-header-button" title="Dock to the side" aria-label="Dock Thomas to the side" (click)="thomas.setMode('docked')">
              <i class="material-icons">view_sidebar</i>
            </button>
          }
          <button type="button" class="thomas-header-button" title="Close" aria-label="Close Thomas" (click)="thomas.open = false">
            <i class="material-icons">close</i>
          </button>
        </span>
      </div>

      <div *dxTemplate="let data of 'content'">
        <js-thomas-chat></js-thomas-chat>
      </div>
    </dx-popup>
  }
}
